(() => {
  let swiperPromise;

  const loadSwiper = () => {
    if (window.Swiper) return Promise.resolve();
    if (swiperPromise) return swiperPromise;

    const load = (type, url) =>
      new Promise((resolve, reject) => {
        const selector = type === 'css' ? `link[href="${url}"]` : `script[src="${url}"]`;

        if (document.querySelector(selector)) {
          resolve();
          return;
        }

        const el = document.createElement(type === 'css' ? 'link' : 'script');

        if (type === 'css') {
          el.rel = 'stylesheet';
          el.href = url;
        } else {
          el.src = url;
        }

        el.onload = resolve;
        el.onerror = reject;
        document.head.appendChild(el);
      });

    swiperPromise = Promise.all([
      load('css', 'https://unpkg.com/swiper/swiper-bundle.min.css'),
      load('js', 'https://unpkg.com/swiper/swiper-bundle.min.js')
    ]);

    return swiperPromise;
  };

  const initDesktopSwiper = (root) => {
    if (window.innerWidth < 1024) return;

    const grid = root.querySelector('[data-search-preview-grid]');
    if (!grid || grid.closest('.swiper')) return;

    const nav = root.parentElement?.querySelector('[data-search-preview-nav]');
    const prevBtn = nav?.querySelector('[data-search-preview-prev]');
    const nextBtn = nav?.querySelector('[data-search-preview-next]');

    loadSwiper()
      .then(() => {
        if (!window.Swiper) return;

        const swiperEl = document.createElement('div');
        swiperEl.className = 'swiper search-preview-collection__swiper';

        const wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        [...grid.children].forEach((node) => {
          node.classList.add('swiper-slide');
          wrapper.appendChild(node);
        });

        grid.parentNode.replaceChild(swiperEl, grid);
        swiperEl.appendChild(wrapper);

        new window.Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: true,
          navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : undefined
        });
      })
      .catch(() => {});
  };

  const init = () => {
    setTimeout(() => {
        document
        .querySelectorAll('[data-search-preview-collection]')
        .forEach((root) => initDesktopSwiper(root));
    }, 100);
   
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
